import { useEffect, useState, useContext } from "react"
import ModalComponent from "../../../CQIPage/components/ModalComponent"
import intl from "react-intl-universal"
import Input from "../../../../atoms/Input"
import Button from "../../../../atoms/Button"
import PlusIcons from "../../../../../assets/icons/PlusIcons"
import { Tooltip } from "../../../../molecules/Tooltip"
import { EditSigma } from "../../../../../assets/icons/Editsigma"
import { Trash } from "../../../../../assets/icons/Trash"
import styles from "./index.module.scss"
import { listDRM } from "../../../../../services/sigma"
import { useParams } from "react-router-dom"
import RcmpLoading from "../../../../atoms/Loading"
import AuthContext from "../../../../../contexts/Auth"
import { fnFormatDateFromUTC } from "../../../../../utils/date"
import WarningIcon from "../../../../../assets/icons/Warning"
import TextArea from "antd/es/input/TextArea"
import CloseIcon from "../../../../../assets/icons/CloseIcon"
import { ReactComponent as CheckCircleBrokenIcon } from "../../../../../assets/icons/iconCheck.svg"

export const ModalDRM = ({
  setBOpenModalDRM,
  analyteSelected,
  loadingBtnDRM,
  postDRM,
  update,
  loading,
  setLoading,
  deleteDRM,
  updateDRM,
  modalDelete,
  setModalDelete,
}) => {
  const [value, setValue] = useState("")
  const [nValue, setNValue] = useState("")
  const [txtReason, setTxtReason] = useState("")
  const [editRowId, setEditRowId] = useState(null)
  const [isEdit, setIsEdit] = useState(false)
  const [dataDRM, setDataDRM] = useState([])
  const { id: idEquipment } = useParams()
  const { oUser } = useContext(AuthContext)
  const [modalReason, setModalReason] = useState(false)
  const [idDRM, setIdDRM] = useState(null)

  const handleChange = (event, callback) => {
    const inputValue = event.target.value
    const regex = /^[0-9,]*$/

    if (regex.test(inputValue)) {
      callback(inputValue)
    }
  }

  const getDRM = async (idEquipment, analyteSelected) => {
    try {
      setValue("")
      setLoading(true)
      const res = await listDRM(idEquipment, analyteSelected.anlt_nid)
      setDataDRM(res.data.data)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getDRM(idEquipment, analyteSelected)
    setTxtReason("")
    setModalReason(false)
  }, [analyteSelected, update])

  const cUserTimeZone = oUser?.data?.user_ctimezone

  const fnCloseAllModal = () => {
    setBOpenModalDRM(false)
    setModalDelete(false)
    setModalReason(false)
  }

  const reset = () => {
    setNValue("")
    setEditRowId(null)

    setIsEdit(false)
  }

  const transformDate = (date) => {
    const [data, hour] = fnFormatDateFromUTC(
      `${date}`,
      "DD/MM/YYYY - HH:mm",
      cUserTimeZone,
    ).split(" - ")

    return data + " • " + hour
  }

  const DRM = () => {
    return (
      <>
        <div className={styles.flexColumn}>
          <div className={styles.flex}>
            <div style={{ width: "100%" }}>
              <Input
                label="Valor"
                width="100%"
                value={value}
                onChange={(e) => handleChange(e, setValue)}
                disabled={loading}
              />
            </div>

            {loadingBtnDRM ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "40%",
                  height: "3rem",
                }}
              >
                <RcmpLoading bShow={true} size={30} />
              </div>
            ) : (
              <Button
                variant={loading ? "disabled" : "transparent"}
                disabled={loading}
                onClick={() => {
                  if (value?.trim() === "") return
                  postDRM(idEquipment, analyteSelected, value?.replace(",", "."))
                }}
              >
                <PlusIcons stroke="#6cb6e3" style={{ marginRight: "0.5rem" }} />

                {intl.get("sigma.add_value")}
              </Button>
            )}
          </div>
        </div>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1rem",
              borderRadius: "4px",
              width: "100%",
            }}
          >
            <RcmpLoading bShow={true} size={50} />
          </div>
        ) : dataDRM.length === 0 ? (
          <>
            <table className={styles.table}>
              <thead className={styles.head}>
                <tr>
                  {[intl.get("value"), intl.get("user"), intl.get("sigma.date_hour")].map(
                    (item, index) => (
                      <th
                        key={index}
                        id={item}
                        className={`${
                          item.toLowerCase().includes("name") ||
                          item.includes("observation")
                            ? styles.widthLarge
                            : styles.widthNormal
                        } th`}
                      >
                        {item}
                      </th>
                    ),
                  )}
                </tr>
              </thead>
            </table>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1rem",
                borderRadius: "4px",
                width: "100%",
              }}
            >
              {intl.get("no_data")}
            </div>
          </>
        ) : (
          <table className={styles.table}>
            <thead className={styles.head}>
              <tr>
                {[intl.get("value"), intl.get("user"), intl.get("sigma.date_hour")].map(
                  (item, index) => (
                    <th
                      key={index}
                      id={item}
                      className={`${
                        item.toLowerCase().includes("name") ||
                        item.includes("observation")
                          ? styles.widthLarge
                          : styles.widthNormal
                      } th`}
                    >
                      {item}
                    </th>
                  ),
                )}
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {dataDRM.map((item, index) => {
                return (
                  <tr
                    key={index}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <td className={`${styles.td}`}>
                      {editRowId === index ? (
                        <Input
                          width="8rem"
                          value={nValue}
                          onChange={(e) => handleChange(e, setNValue)}
                        />
                      ) : (
                        item.eqpanltdrm_nvalue
                      )}
                    </td>
                    <td className={`${styles.td}`}>{item.eqpanltdrm_user.cname}</td>
                    <td className={`${styles.td}`}>
                      {transformDate(item.eqpanltdrm_dupdated)}
                    </td>

                    <td
                      style={{
                        width: "7rem",
                        height: "100%",
                        cursor: "pointer",
                      }}
                    >
                      <div className={styles.containerAction}>
                        {editRowId === index ? (
                          <>
                            <Tooltip
                              icon={<CloseIcon fill="#FF3541" width={20} height={20} />}
                              name={intl.get("cap_back")}
                              fnHandleClick={reset}
                            />
                            <Tooltip
                              icon={
                                <CheckCircleBrokenIcon
                                  stroke="#636d66"
                                  width={22}
                                  height={22}
                                />
                              }
                              name={intl.get("cap_confirm")}
                              fnHandleClick={() => {
                                if (
                                  item.eqpanltdrm_nvalue === nValue ||
                                  nValue?.trim() === ""
                                )
                                  return
                                setIdDRM(item.eqpanltdrm_nid)
                                setModalDelete(true)
                                setModalReason(true)
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <Tooltip
                              icon={<EditSigma />}
                              name={intl.get("edit_cap")}
                              fnHandleClick={() => {
                                setIsEdit(true)
                                setEditRowId(index)
                                setNValue(item.eqpanltdrm_nvalue)
                              }}
                            />
                            <Tooltip
                              icon={<Trash />}
                              name={intl.get("delete_cap")}
                              fnHandleClick={() => {
                                setIdDRM(item.eqpanltdrm_nid)
                                setModalDelete(true)
                              }}
                            />
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        )}

        <div className={styles.flexCenter}>
          <Button variant="outline" onClick={() => setBOpenModalDRM(false)}>
            {intl.get("cap_close")}
          </Button>
        </div>
      </>
    )
  }

  const Delete = () => {
    return modalReason ? (
      <>
        <p>{intl.get("sigma.info_reson")}</p>
        <TextArea
          className={styles.textarea}
          value={txtReason}
          onChange={(e) => setTxtReason(e.currentTarget.value)}
        />
        <Button
          style={{ marginTop: "1rem" }}
          disabled={loadingBtnDRM}
          onClick={() => {
            if (txtReason?.trim() === "") return
            if (isEdit) {
              updateDRM(
                idEquipment,
                analyteSelected.anlt_nid,
                nValue.replace(",", "."),
                idDRM,
                txtReason,
              )
              reset()
              return
            }
            deleteDRM(idEquipment, analyteSelected.anlt_nid, idDRM, txtReason)
          }}
        >
          {intl.get("save_cap")}
        </Button>
      </>
    ) : (
      <>
        <div className={styles.flexWarning}>
          <WarningIcon />
          <p>{intl.get("sigma.info_delete_drm")}</p>
        </div>
        <div className={styles.containerBtns}>
          <Button variant="outline" onClick={() => setModalDelete(false)}>
            {intl.get("ciq.no_i_want_back")}
          </Button>
          <Button variant="negative" onClick={() => setModalReason(true)}>
            {intl.get("ciq.yes_continue")}
          </Button>
        </div>
      </>
    )
  }

  return (
    <ModalComponent
      title={intl.get("sigma.drm_result")}
      fnCloseModal={fnCloseAllModal}
      size={modalDelete ? "md" : "lg"}
    >
      {modalDelete ? Delete() : DRM()}
    </ModalComponent>
  )
}
